const CARDS = [
  {
    num: '01',
    title: 'Intentional Philanthropy',
    text: 'Supporting charitable efforts with purpose, care and consideration.',
  },
  {
    num: '02',
    title: 'Responsible Stewardship',
    text: 'Approaching philanthropic resources with a focus on accountability and thoughtful decision-making.',
  },
  {
    num: '03',
    title: 'Lasting Change',
    text: 'Recognising the importance of sustained efforts in building stronger communities.',
  },
];

export default function ApproachPanel() {
  return (
    <section className="panel" data-side="right" id="approach" aria-labelledby="approach-heading">
      <img
        className="panel-bg"
        src="https://readdy.ai/api/search-image?query=Close%20architectural%20view%20of%20a%20pale%20oak%20desk%20edge%20in%20a%20forest%20green%20study%2C%20an%20ivory%20sheet%20of%20letterhead%20paper%20resting%20on%20the%20wood%2C%20warm%20directional%20sunlight%20from%20the%20side%2C%20deep%20shadows%2C%20muted%20beige%20and%20green%20palette%2C%20restrained%20fine-art%20interior%20photography%20with%20no%20people%20and%20no%20text&width=2400&height=1350&seq=reve-approach-desk&orientation=landscape"
        alt="The edge of an oak desk in a forest green study, with warm directional sunlight across an ivory sheet of paper."
        width="2400"
        height="1350"
        loading="eager"
        fetchPriority="low"
        decoding="async"
        data-parallax="0.32"
      />
      <div className="panel-veil" aria-hidden="true" />
      <span className="panel-accent numeral" data-parallax="0.55" aria-hidden="true">
        04
      </span>

      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>
          04 — Our approach
        </p>
        <h2 id="approach-heading" data-reveal>
          A considered way
          <br />
          of <em className="accent">giving.</em>
        </h2>
        <p className="sub" data-reveal>
          Three principles frame how we think about charitable work — not a description of
          programmes, but the standard we hold ourselves to.
        </p>

        <ul className="cards">
          {CARDS.map((c) => (
            <li key={c.num} data-reveal>
              <span className="num">{c.num}</span>
              <span>
                <span className="ttl">{c.title}</span>
                <span className="txt">{c.text}</span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}